export default __webpack_public_path__ + "static/media/brand-9.e4d27361.png";